<template>
  <!-- TO DO improvement: isInlineDescription dibikin true aja & is-inline-description bisa dihapus karena yg ga inline cuma di reviewAttandance-->
  <mp-banner v-if="isShow" :variant="type" :align-items="isInlineDescription ? 'center' : 'start'" py="3">
    <mp-banner-icon />
    <mp-box :as="isInlineDescription ? 'mp-flex' : 'mp-box'">
      <mp-box>
        <mp-banner-title v-if="title">{{ title }}</mp-banner-title>
        <mp-banner-description
          ><slot>{{ description }}</slot></mp-banner-description
        >
      </mp-box>
      <mp-box v-if="linksHref.length" :ml="isInlineDescription ? 1 : 0" :mt="isInlineDescription ? 0 : 3">
        <mp-banner-link v-for="(link, index) in linksHref" :key="link">
          <a :href="link" :target="linksTarget[index]">{{ linksText[index] }}</a>
        </mp-banner-link>
      </mp-box>
    </mp-box>
    <mp-banner-close-button v-if="dismissible" @click.native="isShow = false" />
  </mp-banner>
</template>
<script>
export default {
  name: 'Info',
  props: {
    type: {
      type: String,
      default: 'info', // info, warning, danger
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    dismissible: {
      type: Boolean,
      default: false,
    },
    isInlineDescription: {
      type: Boolean,
      default: false,
    },
    linksText: {
      type: Array,
      default() {
        return ['here'];
      },
    },
    linksHref: {
      type: Array,
      default() {
        return [];
      },
    },
    linksTarget: {
      type: Array,
      default() {
        return ['_blank'];
      },
    },
  },
  data() {
    return {
      isShow: true,
    };
  },
};
</script>
